<template>
    <div id="app">
        <button class="orangebtn tw-text-white tw-font-medium tw-py-3 tw-rounded tw-tracking-wide tw-px-3" @click="greet">
            <img src="/img/plus.svg"/> 
        </button>
    </div>
</template>

<script>
    export default {
        props: {
            name: {
                required: true,
                type: String,
            },
            type: {
                required: true,
                type: String,
            }
        },
        data() {
            return {
                name: this.value
            }
        },

        methods: {
            greet() {
                return 'Hello';
            }
        }
    }
</script>